import ajax from '@/libs/api.request'

export default {
  dotest1:param => {
    return ajax.get("test/dotest",param);
  },
  dotest2:param => {
    return ajax.post("test/dotest",param);
  },
  dotest3:()=>{
    return ajax.get("test/dotest");
  }
}
